import Vue from "vue";
import axios from 'axios';

const version = 'v1';
const getAllInstanceAppSettingsApi = `${version}/InstanceAppSetting/getAll`;
const addInstanceAppSettingsApi = `${version}/InstanceAppSetting/add`;
const updateInstanceAppSettingsApi = `${version}/InstanceAppSetting/update`;
const deleteInstanceAppSettingsApi = `${version}/InstanceAppSetting/delete`;
const getDecryptedValueApi = `${version}/InstanceAppSetting/getDecryptedValue`;

export const state = Vue.observable({
    instanceAppSettings: [],
    instanceAppSettingsCount: 0
});

export const mutations = {
    async setInstanceAppSetting(params = {}) {
        var res = await axios.post(getAllInstanceAppSettingsApi, params);
        state.instanceAppSettings = res?.data?.result?.items;
        state.instanceAppSettingsCount = res?.data?.result?.totalCount;
    },
    async addInstanceAppSetting(InstanceAppSetting) {
        let response =  await axios.post(addInstanceAppSettingsApi, InstanceAppSetting);
        await this.setInstanceAppSetting();
        return response;

    },
    async updateInstanceAppSetting(InstanceAppSetting) {
        let response = await axios.put(updateInstanceAppSettingsApi, InstanceAppSetting);
        await this.setInstanceAppSetting();
        return response;
    },
    async deleteInstanceAppSetting(InstanceAppSettingId) {
        let response = await axios.delete(`${deleteInstanceAppSettingsApi}/${InstanceAppSettingId}`);
        await this.setInstanceAppSetting();
        return response;
    },
	async getDecryptedValue(InstanceAppSettingId){
		const response = await axios.get(`${getDecryptedValueApi}/${InstanceAppSettingId}`);
		return response;
	}
};